import { motion } from "framer-motion";
import { Star, Users, Gauge, Bot } from "lucide-react";
import { HERO } from "@/constants/testIds";

const badges = [
  { icon: Star, label: "4.9/5 average rating" },
  { icon: Users, label: "120+ businesses transformed" },
  { icon: Gauge, label: "98 avg Lighthouse score" },
  { icon: Bot, label: "24/7 AI concierge" },
];

export const TrustBadges = () => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, delay: 1.1, ease: [0.16, 1, 0.3, 1] }}
    className="mt-10 flex flex-wrap items-center gap-3"
  >
    {badges.map((badge, i) => (
      <div
        key={badge.label}
        data-testid={HERO.trustBadge(i)}
        className="flex items-center gap-2 rounded-full border border-white/[0.08] bg-white/[0.03] px-4 py-2 text-xs font-medium text-white/72 backdrop-blur-sm"
      >
        <badge.icon className="h-3.5 w-3.5 text-brand-accent" strokeWidth={2} />
        {badge.label}
      </div>
    ))}
  </motion.div>
);
